import { Component, OnInit } from '@angular/core';
import { DialogConfig } from '../dialog/dialog-config';
import { DialogRef } from '../dialog/dialog-ref';
import {
  ProgressSeminarScheduleLinkDialogResult,
  ProgressSeminarScheduleLinkDialogSchedule,
} from './progress-seminar-schedule-link-dialog-interface';

@Component({
  selector: 'ag-progress-seminar-schedule-link-dialog',
  templateUrl: './progress-seminar-schedule-link-dialog.component.html',
  styleUrls: ['./progress-seminar-schedule-link-dialog.component.scss'],
})
export class ProgressSeminarScheduleLinkDialogComponent implements OnInit {
  public selectedScheduleId: number = null;

  constructor(
    public dialog: DialogRef,
    public config: DialogConfig<{ schedules: ProgressSeminarScheduleLinkDialogSchedule[] }>
  ) {}

  ngOnInit() {
    if (!this.config.data || !this.config.data.schedules || !this.config.data.schedules.length) {
      this.close();
      return;
    }

    if (this.isSingleSchedule) {
      this.selectedScheduleId = this.config.data.schedules[0].id;
    }
  }

  get canSubmit(): boolean {
    return !!this.selectedScheduleId && !this.dialog.inClose;
  }

  get isSingleSchedule(): boolean {
    return this.config.data.schedules.length === 1;
  }

  public close(result?: ProgressSeminarScheduleLinkDialogResult): void {
    this.dialog.close(result);
  }

  public submit(): void {
    if (!this.canSubmit) {
      return;
    }
    this.close({ jobSettingSeminarScheduleId: this.selectedScheduleId });
  }
}
